// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-container {
  max-width: 80%;
  margin: 40px auto;
  padding: 24px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
}

.project-description {
  background: #f7faff;
  border-left: 5px solid #007bff;
  padding: 24px 24px 16px 24px;
  border-radius: 10px;
  margin-bottom: 32px;
  text-align: left; /* Ensure left alignment */
}

.project-description h1 {
  margin-top: 0;
  color: #007bff;
  font-size: 2rem;
  font-weight: 700;
  text-align: left; /* Ensure left alignment for heading */
}

.project-description ol {
  margin: 16px 0 8px 20px;
  padding-left: 20px;
  color: #333;
  font-size: 1.05rem;
  text-align: left; /* Ensure left alignment for list */
}

.project-description li, .project-description ul {
  margin-bottom: 6px;
  text-align: left; /* Ensure left alignment for list items */
}

.project-description p {
  margin: 0;
  color: #444;
  font-size: 1rem;
  text-align: left; /* Ensure left alignment for paragraph */
}

.upload-section {
  margin-top: 24px;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.select-input, .file-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  flex: 1 1;
  background-color: white;
}

.select-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.upload-controls {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 16px;
}

.upload-button {
  padding: 8px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}

.upload-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.loading-container {
  margin: 20px 0;
  text-align: center;
}

.loading-bar {
  width: 100%;
  height: 4px;
  background-color: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
}

.loading-progress {
  width: 30%;
  height: 100%;
  background-color: #007bff;
  border-radius: 2px;
  animation: progress 1s infinite linear;
}

.loading-text {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}

@keyframes progress {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}

.error-message {
  color: #d8000c;
  background: #ffd2d2;
  border: 1px solid #d8000c;
  border-radius: 4px;
  padding: 10px;
  margin: 16px 0;
  font-size: 1rem;
}

.selected-files {
  margin-top: 16px;
  background: #f9f9f9;
  border-radius: 6px;
  padding: 12px;
}

.selected-files h4 {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  color: #007bff;
}

.selected-files ul {
  margin: 0;
  padding-left: 18px;
  color: #333;
  font-size: 0.98rem;
}

.project-description ol {
  padding-left: 20px;
  color: #333;
  font-size: 1.05rem;
  text-align: left;
  margin: 0; /* Remove margin */
}

.text-input {
  width: 100%;
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.text-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.find-replace-section {
  margin: 20px 0;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.find-replace-section .form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.find-replace-section .text-input {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.find-replace-section .text-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.find-replace-section .text-input::placeholder {
  color: #6c757d;
}

.find-replace-section .replace-button {
  padding: 10px 20px;
  background-color: #dc6a10;  
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.find-replace-section .replace-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.find-replace-section .replace-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

.date-range-group {
  margin: 1rem 0;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.date-range-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #495057;
}

.date-inputs-wrapper {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.date-input-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
}

.date-label {
  font-size: 0.875rem;
  color: #6c757d;
  min-width: 3rem;
}

.date-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.date-input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  outline: 0;
}


.date-picker-container {
  margin: 1rem 0;
}

.date-picker-container label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #495057;
}

.date-range-input {
  width: 600px;
  padding: 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  color: #495057;
  background-color: white;
  cursor: pointer;
}

.date-range-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

/* Override datepicker styles */
.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker__input-container {
  width: 100%;
}

.react-datepicker-popper {
  z-index: 999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/FileUpload.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS,EAAE,kBAAkB;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;AACZ;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".file-upload-container {\n  max-width: 80%;\n  margin: 40px auto;\n  padding: 24px;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n}\n\n.project-description {\n  background: #f7faff;\n  border-left: 5px solid #007bff;\n  padding: 24px 24px 16px 24px;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  text-align: left; /* Ensure left alignment */\n}\n\n.project-description h1 {\n  margin-top: 0;\n  color: #007bff;\n  font-size: 2rem;\n  font-weight: 700;\n  text-align: left; /* Ensure left alignment for heading */\n}\n\n.project-description ol {\n  margin: 16px 0 8px 20px;\n  padding-left: 20px;\n  color: #333;\n  font-size: 1.05rem;\n  text-align: left; /* Ensure left alignment for list */\n}\n\n.project-description li, .project-description ul {\n  margin-bottom: 6px;\n  text-align: left; /* Ensure left alignment for list items */\n}\n\n.project-description p {\n  margin: 0;\n  color: #444;\n  font-size: 1rem;\n  text-align: left; /* Ensure left alignment for paragraph */\n}\n\n.upload-section {\n  margin-top: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n  display: flex;\n  gap: 10px;\n}\n\n.select-input, .file-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  flex: 1;\n  background-color: white;\n}\n\n.select-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.upload-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.upload-button {\n  padding: 8px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.upload-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.loading-container {\n  margin: 20px 0;\n  text-align: center;\n}\n\n.loading-bar {\n  width: 100%;\n  height: 4px;\n  background-color: #f0f0f0;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.loading-progress {\n  width: 30%;\n  height: 100%;\n  background-color: #007bff;\n  border-radius: 2px;\n  animation: progress 1s infinite linear;\n}\n\n.loading-text {\n  margin-top: 10px;\n  color: #666;\n  font-size: 14px;\n}\n\n@keyframes progress {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(400%);\n  }\n}\n\n.error-message {\n  color: #d8000c;\n  background: #ffd2d2;\n  border: 1px solid #d8000c;\n  border-radius: 4px;\n  padding: 10px;\n  margin: 16px 0;\n  font-size: 1rem;\n}\n\n.selected-files {\n  margin-top: 16px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.selected-files h4 {\n  margin: 0 0 8px 0;\n  font-size: 1.1rem;\n  color: #007bff;\n}\n\n.selected-files ul {\n  margin: 0;\n  padding-left: 18px;\n  color: #333;\n  font-size: 0.98rem;\n}\n\n.project-description ol {\n  padding-left: 20px;\n  color: #333;\n  font-size: 1.05rem;\n  text-align: left;\n  margin: 0; /* Remove margin */\n}\n\n.text-input {\n  width: 100%;\n  padding: 10px;\n  margin: 5px 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.find-replace-section {\n  margin: 20px 0;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.find-replace-section .form-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.find-replace-section .text-input {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.find-replace-section .text-input:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.find-replace-section .text-input::placeholder {\n  color: #6c757d;\n}\n\n.find-replace-section .replace-button {\n  padding: 10px 20px;\n  background-color: #dc6a10;  \n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.find-replace-section .replace-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.find-replace-section .replace-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.date-range-group {\n  margin: 1rem 0;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.date-range-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #495057;\n}\n\n.date-inputs-wrapper {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.date-input-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.date-label {\n  font-size: 0.875rem;\n  color: #6c757d;\n  min-width: 3rem;\n}\n\n.date-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.date-input:focus {\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);\n  outline: 0;\n}\n\n\n.date-picker-container {\n  margin: 1rem 0;\n}\n\n.date-picker-container label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #495057;\n}\n\n.date-range-input {\n  width: 600px;\n  padding: 0.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 1rem;\n  color: #495057;\n  background-color: white;\n  cursor: pointer;\n}\n\n.date-range-input:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);\n}\n\n/* Override datepicker styles */\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker__input-container {\n  width: 100%;\n}\n\n.react-datepicker-popper {\n  z-index: 999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
